export const API = "API";
export const CORE_API = "CORE_API";
export const NBSK_API = "NBSK";
export const PLUGIN = "PLUGIN";
export const PLUGIN_API = "PLUGIN_API";
export const WEB = "WEB";
